import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './auth/auth-guard.service';
import {Error404Component} from './error-404/error-404.component';
import {FriendsComponent} from './friends/friends.component';
import {HomeComponent} from './home/home.component';
import {NotPermittedComponent} from './not-permitted/not-permitted.component';

const routes: Routes = [
    {path: '', redirectTo: 'kezdolap', pathMatch: 'full'},
    {path: 'kezdolap', component: HomeComponent},
    {path: 'barataink', component: FriendsComponent},
    {path: 'felhasznalo', canActivate: [AuthGuard], loadChildren: './user/user.module#UserModule', runGuardsAndResolvers: 'always'},
    {path: 'admin', canActivate: [AuthGuard], loadChildren: './administration/administration.module#AdministrationModule', runGuardsAndResolvers: 'always'},
    // {path: 'email', loadChildren: './email/email.module#EmailModule', runGuardsAndResolvers: 'always'},
    {path: 'dicsi', loadChildren: './worship/worship.module#WorshipModule', runGuardsAndResolvers: 'always'},
    {path: 'taborozo', loadChildren: './camper/camper.module#CamperModule', runGuardsAndResolvers: 'always'},
    {path: 'jogosulatlan', component: NotPermittedComponent},
    {path: '**', component: Error404Component}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/app-routing.module.ts